// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","pFooter":"Footer_pFooter__M45nt","aFooter":"Footer_aFooter__2NCmq"};